import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom'
import * as Helper from '../../../util/Helper';
import StatusCode from '../../../util/StatusCode';
import { GetGroup } from '../../../store/GroupAction';
import TableVertical from '../../misc/TableVertical';
import { CoreStudentGroup } from '../../../models/CoreGroup';
import { RequestState } from '../../../models/RequestState';
import { useTranslation } from 'react-i18next';
import { RootState } from '../../../store/store';



const GroupViewInfo = () => {
    const { t } = useTranslation(['schoolAdministration', 'common']);

    const { groupId } = useParams();
    const dispatch = useDispatch();
    const group = useSelector<RootState, RequestState<CoreStudentGroup>>(state => state.groups.group);

    useEffect(() => {
        if (groupId !== undefined) {
            GetGroup(groupId)(dispatch);
        }
    }, [dispatch, groupId]);

    const renderGroupInfo = () => {
        let groupInfo = [];
        if (group.code === StatusCode.COMPLETE) {
            const c = group.data;
            groupInfo.push(
                { header: t('genericTableHeaders.name', {ns: 'common'}), content: c.title },
                { header: t('genericTableHeaders.active', { ns: 'common' }), content: Helper.active(c.active) },
                { header: t('commonTableHeaders.schoolUnit', { ns: 'schoolAdministration' }), content: c.schoolUnit && <Link to={`/schoolunit/${c.schoolUnit.id}/information`}> { c.schoolUnit.title }</Link> },
                { header: t('commonTableHeaders.groupType', { ns: 'schoolAdministration' }), content: c.studentGroupType ? t('groupTypes.' + c.studentGroupType.id, { ns: 'schoolAdministration' }) : '-' },
                { header: t('genericTableHeaders.startDate', { ns: 'common' }), content: Helper.formatDateOnly(c.startDate) },
                { header: t('genericTableHeaders.endDate', { ns: 'common' }), content: Helper.formatDateOnly(c.endDate) },
                { header: t('genericTableHeaders.created', { ns: 'common' }), content: Helper.formatDate(c.created) },
                { header: t('genericTableHeaders.modified', { ns: 'common' }), content: Helper.formatDate(c.modified) },
            )
        }
        return (
            <TableVertical
                header={t('commonTableHeaders.information', { ns: 'schoolAdministration' })}
                info={groupInfo}
                error={group.code === StatusCode.ERROR}
                searching={group.code === StatusCode.PENDING}
            />
        )
    }

    return (<>
        {renderGroupInfo()}
    </>);
}

export default GroupViewInfo;
